<template>
  <div class="home">
    <div class="container-fluid">
      <div class="row">
        <div class="col p-0">
          <TopBarMember />
        </div>
      </div>
    </div>
    <div class="container px-0 px-sm-3">
      <div class="row mx-0">
        <div class="bar-back col d-flex justify-content-between align-items-center">
          <router-link to="/lottery" class="mr-auto text-secondary">
            <i class="fas fa-chevron-left"></i> หน้าหลัก
          </router-link>
        </div>
      </div>
      <div
        class="p-2 w-100 bg-light main-content align-self-stretch"
        style="min-height: calc((100vh - 94px) - 90px);"
      >
        <div class="bgwhitealpha text-secondary shadow-sm rounded p-2 xtarget col-lotto mb-1 pb-0">
          <div class="pb-0">
            <YeekeeStat />
            <div class="card mb-1 w-100">
              <div
                class="card-header bg-dark text-light titlestyle d-flex justify-content-between align-items-center p-2"
              >
                <div>หวยเด่น</div>
                <div>
                  <a :href="getSiteUrl + '/app.apk'"  class="btn btn-outline-secondary btn-sm pb-0">
                    <i class="fab fa-google-play"></i>
                    <i class="fab fa-app-store-ios"></i>
                    แทงหวยผ่านแอป
                  </a>
                </div>
              </div>

              <div class="card-body p-1 titlestyle border border-dark">
                <div class="row px-3">
                  <!-- จับยี่กี -->
                  <div
                    class="col-6 col-sm-6 col-md-4 col-lg-3 p-1"
                    v-if="games.filter( i => isDisabled.includes( i.isBetAvailable )).length > 0 && games.filter( i => isDisabled.includes( i.isBetAvailable ))[games.filter( i => isDisabled.includes( i.isBetAvailable )).length-1].isDiceAvailable"
                  >
                    <router-link :to="'/lottery/yeekee/PingPongVIP/' + games.filter( i => isDisabled.includes( i.isBetAvailable ))[games.filter( i => isDisabled.includes( i.isBetAvailable )).length-1].pingPongReferID">
                      <div class="boxhuay">
                        <div class="head-huay goldpattern align-items-stretch">
                          <div class="headflag">
                            <span class="bg-warning fullflag font-number">{{ games.filter( i => isDisabled.includes( i.isBetAvailable ))[games.filter( i => isDisabled.includes( i.isBetAvailable )).length-1].roundNumber }}</span>
                          </div>
                          <div class="headtxt flex-fill">
                            <div class="pt-1 pr-1">หวยยี่กี</div>
                            <div class="subhead-huay">ปิดรับ {{ formatDate(games.filter( i => isDisabled.includes( i.isBetAvailable ))[games.filter( i => isDisabled.includes( i.isBetAvailable )).length-1].pingPongDate) }}</div>
                          </div>
                        </div>
                        <div class="body-huay">
                          <span class="text-secondary">
                            <i class="far fa-calendar-times"></i> ปิดรับแทง
                          </span>
                          <!-- {{games.filter( i => isDisabled.includes( i.isBetAvailable ))[games.filter( i => isDisabled.includes( i.isBetAvailable )).length-1].pingPongDate}} -->
                          <span class="countdown style colorDefinition size_lg">
                            <vue-countdown
                              :time="getTimeLeftDice(games.filter( i => isDisabled.includes( i.isBetAvailable ))[games.filter( i => isDisabled.includes( i.isBetAvailable )).length-1].pingPongDate)"
                              v-slot="{ days, hours, minutes, seconds }"
                              @end="getGames()"
                              
                            >
                              <span v-if="days > 0">
                                {{zeroPad(days, 2)}}
                                <sup>วัน</sup>
                              </span>
                              {{zeroPad(hours, 2)}}:{{zeroPad(minutes, 2)}}:{{zeroPad(seconds, 2)}}
                            </vue-countdown>
                          </span>
                        </div>
                      </div>
                    </router-link>
                  </div>
                  <!-- จับยี่กี -->
                  
                  <!-- จับยี่กี -->
                  <div
                    class="col-6 col-sm-6 col-md-4 col-lg-3 p-1"
                    v-for="(item,index) in games.filter( i => notDisabled.includes( i.isBetAvailable ))"
                    v-bind:key="item.roundNumber"
                  >
                    <router-link :to="'/lottery/yeekee/PingPongVIP/' + item.pingPongReferID">
                      <div :class="['boxhuay', item.isBetAvailable ? '' : 'disabled']">
                        <div class="head-huay goldpattern align-items-stretch">
                          <div class="headflag">
                            <span class="bg-warning fullflag font-number">{{ item.roundNumber }}</span>
                          </div>
                          <div class="headtxt flex-fill">
                            <div class="pt-1 pr-1">หวยยี่กี</div>
                            <div class="subhead-huay">ปิดรับ {{ formatDate(item.pingPongDate) }}</div>
                          </div>
                        </div>
                        <div class="body-huay">
                          <span class="countdown style colorDefinition size_lg">
                            <vue-countdown
                              :time="getTimeLeft(item.pingPongDate)"
                              v-slot="{ days, hours, minutes, seconds }"
                              @end="getGames()"
                            >
                              <span v-if="days > 0">
                                {{zeroPad(days, 2)}}
                                <sup>วัน</sup>
                              </span>
                              {{zeroPad(hours, 2)}}:{{zeroPad(minutes, 2)}}:{{zeroPad(seconds, 2)}}
                            </vue-countdown>
                          </span>
                        </div>
                      </div>
                    </router-link>
                  </div>
                  <!-- จับยี่กี -->
                  <!-- จับยี่กี -->
                  <div
                    class="col-6 col-sm-6 col-md-4 col-lg-3 p-1"
                    v-for="(item,index) in games.filter( i => isDisabled.includes( i.isDiceAvailable ))"
                    v-bind:key="item.roundNumber"
                  >
                    <router-link :to="'/lottery/yeekee/PingPongVIP/' + item.pingPongReferID">
                      <div :class="['boxhuay', item.isBetAvailable ? '' : 'disabled']">
                        <div class="head-huay goldpattern align-items-stretch">
                          <div class="headflag">
                            <span class="bg-warning fullflag font-number">{{ item.roundNumber }}</span>
                          </div>
                          <div class="headtxt flex-fill">
                            <div class="pt-1 pr-1">หวยยี่กี</div>
                            <div class="subhead-huay">ปิดรับ {{ formatDate(item.pingPongDate) }}</div>
                          </div>
                        </div>
                        <div class="body-huay">
                          <span class="text-secondary">
                            <i class="far fa-calendar-times"></i> ยังไม่รับแทง
                          </span>
                        </div>
                      </div>
                    </router-link>
                  </div>
                  <!-- จับยี่กี -->

                  <!-- จับยี่กี -->
                  <!-- <div class="col-6 col-sm-6 col-md-4 col-lg-3 p-1">
                    <router-link to="/lottery/tangyeekee">
                      <div class="boxhuay disabled">
                        <div class="head-huay goldpattern align-items-stretch">
                          <div class="headflag">
                            <span class="bg-warning fullflag font-number">22</span>
                          </div>
                          <div class="headtxt flex-fill">
                            <div class="pt-1 pr-1">หวยยี่กี</div>
                            <div class="subhead-huay">ปิดรับ 11:15</div>
                          </div>
                        </div>
                        <div class="body-huay">
                          <span class="text-secondary">
                            <i class="far fa-calendar-"></i> ยังไม่รับแทง
                          </span>
                        </div>
                      </div>
                    </router-link>
                  </div>-->
                  <!-- จับยี่กี -->

                  <!-- จับยี่กี -->
                  <!-- <div class="col-6 col-sm-6 col-md-4 col-lg-3 p-1">
                    <router-link to="/lottery/tangyeekee">
                      <div class="boxhuay">
                        <div class="head-huay goldpattern align-items-stretch">
                          <div class="headflag">
                            <span class="bg-warning fullflag font-number">22</span>
                          </div>
                          <div class="headtxt flex-fill">
                            <div class="pt-1 pr-1">หวยยี่กี</div>
                            <div class="subhead-huay">ปิดรับ 11:15</div>
                          </div>
                        </div>
                        <div class="body-huay">
                          <span class="countdown style colorDefinition size_lg" id="88715">00:59:09</span>
                        </div>
                      </div>
                    </router-link>
                  </div>-->
                  <!-- จับยี่กี -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterIndex class="mt-3" />
  </div>
</template>

<script>
import TopBarMember from "@/components/TopBarMember.vue";
import LottoMenu from "@/components/LottoMenu.vue";
import FooterIndex from "@/components/Footer.vue";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
import VueCountdown from "@chenfengyuan/vue-countdown";
import YeekeeStat from "@/components/YeekeeStat.vue";

export default {
  name: "Yeekee",
  components: {
    TopBarMember,
    LottoMenu,
    FooterIndex,
    VueCountdown,
    YeekeeStat,
  },
  data() {
    return {
      games: [],
      isDisabled: [false],
      notDisabled: [true],
      times: []
    };
  },
  mounted() {
    this.getGames();
    // console.log(
    //   moment()
    //     .endOf("day", "HH:mm:ss")
    //     .fromNow()
    // );
    // console.log('current time', this.currentTime);
  },
  methods: {
    formatDate(dt) {
      return moment(String(dt)).format("HH:mm");
    },
    zeroPad(num, places) {
      const zero = places - num.toString().length + 1;
      return Array(+(zero > 0 && zero)).join("0") + num;
    },
    getDate(dt) {
      return Date.parse(dt);
    },
    getTimeLeft(dt) {
      return moment(dt).diff(moment());
    },
    getTimeLeftDice(dt) {
      return moment(dt).add(2, 'minutes').diff(moment());
    },
    formatSecond(dt) {
      // return moment(moment(dt).diff(moment())).format('HH:mm:ss');
      const timeleft = moment(dt).diff(moment());
      const duration = moment.duration(timeleft);
      const theTime =
        this.zeroPad(duration.hours(), 2) +
        ":" +
        this.zeroPad(duration.minutes(), 2) +
        ":" +
        this.zeroPad(duration.seconds(), 2);
      return theTime;
    },
    getGames() {
      axios
        .post(
          this.getApiUrl + "/pingpong/getavailablepingpongtimetable",
          {
            lottoType: 1
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: this.getAccessToken,
              username: this.getUsername
            }
          }
        )
        .then(response => {
          this.games = response.data.data;
          console.log("games", this.games);
        });
    }
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUsername: "getUsername",
      getApiUrl: "getApiUrl",
      getSiteUrl: "getSiteUrl"
    }),
    timers() {
      return this.times.map(then => moment(this.now).to(then));
    }
  }
};
</script>

<style lang="scss" scoped>
//background: url(../../assets/images/gold-white.jpg) top center;
//background: url(../../assets/images/silver-pattern.jpg) top center;
.countdown {
  font-family: "Gugi", cursive, SukhumvitReg;
}

.boxhuay.disabled {
  -webkit-filter: grayscale(1) opacity(0.7); /* Safari 6.0 - 9.0 */
  filter: grayscale(1) opacity(0.7);
  pointer-events: none;
}

a:link {
  text-decoration: none;
}

.top {
  border: 1px #333 solid;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  display: block;
  margin-top: 10px;
  padding: 10px 0;
  background: #222;
  color: lightgoldenrodyellow;
  line-height: 1;
}

.font-number {
  font-family: "Gugi", cursive;
}

.linkback {
  color: gray;
  text-decoration: none;
}

.content {
  border: 1px #333 solid;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  background: #eee;
  display: block;
  padding: 5px 5px;
  margin-bottom: 10px;
}

.titlestyle {
  font-size: 120%;
  line-height: 1;
}

.boxhuay {
  width: 100%;
  display: block;
  margin: 0 auto;
  background: white;
  border-radius: 3px;
  overflow: hidden;
  border: rgba(0, 0, 0, 0.5) 1px solid;
}

.goldpattern {
  background: url(../../assets/images/gold-white.jpg) top center;
  background-size: 100%;
}

.silverpattern {
  background: url(../../assets/images/silver-pattern.jpg) top center;
  background-size: 100%;
}

.head-huay {
  width: 100%;
  height: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: stretch;
}

.head-yeekee {
  background: url(../../assets/images/gold-white.jpg) top center;
  background-size: 100%;
}

.headflag {
  width: 65px;
  overflow: hidden;
  align-self: stretch;
  border-right: 1px solid rgba(0, 0, 0, 0.5);
}

span > i {
  font-size: 25px;
  color: rgba(0, 0, 0, 0.8);
}

.fullflag {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  background-size: cover;
  height: 100%;
  width: 100%;
}

.headtxt {
  text-align: right;
  font-weight: 700;
  /* text-shadow: rgb(0 0 0 / 90%) 0px 0px 3px; */
  color: rgb(255, 255, 255);
  text-shadow: rgb(0 0 0) 2px 0px 0px, rgb(0 0 0) 1.75517px 0.958851px 0px,
    rgb(0 0 0) 1.0806px 1.68294px 0px, rgb(0 0 0) 0.141474px 1.99499px 0px,
    rgb(0 0 0) -0.832294px 1.81859px 0px, rgb(0 0 0) -1.60229px 1.19694px 0px,
    rgb(0 0 0) -1.97998px 0.28224px 0px, rgb(0 0 0) -1.87291px -0.701566px 0px,
    rgb(0 0 0) -1.30729px -1.5136px 0px, rgb(0 0 0) -0.421592px -1.95506px 0px,
    rgb(0 0 0) 0.567324px -1.91785px 0px, rgb(0 0 0) 1.41734px -1.41108px 0px,
    rgb(0 0 0) 1.92034px -0.558831px 0px;
  letter-spacing: 0.04em;
}

.subhead-huay {
  display: block;
  padding: 2px 2px 1px 2px;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  color: gold;
  text-shadow: rgba(0, 0, 0, 1) 1px 1px 2px;
  font-size: 80%;
  font-weight: 600;
}

.head-yeekee {
  background: url(../../assets/images/gold-black.jpg) top center;
  background-size: 100%;
}

.body-huay {
  width: 100%;
  display: block;
  background: #252525;
  text-align: right;
  color: white;
  padding: 8px 5px;
  font-size: 20px;
}

.headflag > span > i {
  font-size: 25px;
  color: rgba(0, 0, 0, 0.8);
}

.headflag > span.font-number {
  font-size: 24px;
  letter-spacing: normal;
  color: black;
  text-shadow: rgba(255, 255, 255, 0.5) 1px 1px 0;
}

@media screen and (max-width: 576.98px) {
  .headtxt {
    font-size: 16px;
    line-height: 16px;
  }
  .headflag {
    width: 35px;
  }
  .body-huay {
    font-size: 18px;
    padding: 8px 0;
  }
}
@media screen and (max-width: 320px) {
  .headtxt {
    font-size: 14px;
    line-height: 14px;
  }
  .headflag {
    width: 30px;
  }
  .subhead-huay {
    font-size: 80%;
    letter-spacing: normal;
  }
}
</style>